import React from "react";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Button } from "react-bootstrap";
import InstaShareSteps from "../../../images/v2/insta-share-step.png";
import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "react-toastify";

const InstaShareModal = (props) => {
  const { show, hide, shareLink, isMobile, onShare } =
    props;
    
  // for mobile devices card will be shared on insta stories 
  // for web card can be downloaded and shared manually
  const handleInstaShare = async () => {
    try {
      await onShare()
    } catch (error) {
      throw error;
    }
  };

  return (
    <Modal
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-custom-width"
      backdrop="static"
      show={show}
    >
      <Modal.Body className="pt-32 pb-32">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => hide()}
        ></button>
        <Row className="mb-4">
          {!isMobile?
          <h2 className="f-size-24 text-center mb-0 p-0">
          Download your image and <br/>
          paste your link in your story 🔗
          </h2>:<h2 className="f-size-20 text-center mb-0 p-0">
          Make sure you add the link to your
          want-listing to your story 🔗
          </h2>
          }
        </Row>
        <Row>
          <Col xl={12} className="mb-4">
            <div style={{ width: "100%", height: "100%" }}>
              <img
                src={InstaShareSteps}
                alt="insta-share-steps"
                className="image-contained"
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xl={12} className="mb-12">
            <div className="modal-btn-wrap">
              <Button
                variant="primary"
                className={true ? " btn w-100" : "btn w-100 disabled"}
                onClick={handleInstaShare}
              >
                {isMobile ? "Continue to Instagram stories" : "Download Story Image"}
              </Button>
            </div>
          </Col>
          <Col xl={12}>
            <div className="modal-btn-wrap">
              <CopyToClipboard text={shareLink}>
                <Button
                  variant=""
                  className="btn w-100 plans-text-color"
                  onClick={() => {
                    if (shareLink) {
                      toast.success("Link copied to clipboard");
                    }
                  }}
                >
                  Copy link
                </Button>
              </CopyToClipboard>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default InstaShareModal;
